import { render, staticRenderFns } from "./shici.vue?vue&type=template&id=1df3e780&scoped=true"
import script from "./shici.vue?vue&type=script&lang=js"
export * from "./shici.vue?vue&type=script&lang=js"
import style0 from "./shici.vue?vue&type=style&index=0&id=1df3e780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3e780",
  null
  
)

export default component.exports